import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProcessorInput } from '@domain/models/core.models';

export const valueStartsBy = (
  value: number | string,
  searchString: number | string
): boolean => {
  return value.toString().startsWith(searchString.toString());
};

export const generateFormFromProcessorInput = (
  fields: ProcessorInput[]
): FormGroup => {
  const formGroup: FormGroup = new FormGroup({});
  for (const field of fields) {
    const validators = [];
    if (field.attributes.required) {
      validators.push(Validators.required);
    }
    if (field.attributes.pattern) {
      validators.push(Validators.pattern(field.attributes.pattern));
    }
    const fieldControl = new FormControl(null, validators);
    formGroup.addControl(field.attributes.name, fieldControl);
  }

  return formGroup;
};

/**
 * Save file or FileList in the window object
 *
 * @param {string} property File key
 * @param {Event} [event] Html Event to use
 * @param {(File | FileList)} [file] File or FileList to use
 */
export const saveFilesIntoWindowObject = (
  property: string,
  event?: Event,
  file?: File | FileList
): void => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const windowRef = window as any;
  const oldFormData: Record<string, File | FileList> = windowRef.formData || {};
  const files = file || (event?.target as HTMLInputElement | undefined)?.files;
  windowRef.formData = {
    ...oldFormData,
    [property]: files
  };
};

/**
 * Return last saved file or file list into window object
 *
 * @return {*}  {(Record<string, File | FileList>
 *   | undefined)}
 */
export const getFilesIntoWindowObject = ():
  | Record<string, File | FileList>
  | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const windowRef = window as any;
  return windowRef.formData as Record<string, File | FileList> | undefined;
};

/**
 * Clear saved files in window object
 *
 */
export const clearFilesIntoWindowObject = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const windowRef = window as any;
  windowRef.formData = undefined;
};
